// ==============================================
// API CONFIG
// ==============================================
// Single source of truth for the Node/Express backend URL used by
// affiliates, admin, Stripe checkout, etc.
//
// The value comes from `REACT_APP_SERVER_URL`, which is set per
// environment:
//   - client/.env             →  http://localhost:5255   (dev / `npm start`)
//   - client/.env.production  →  https://api.joinsarv.com (prod / `npm run build`)
//
// CRA inlines REACT_APP_* vars as string literals at build time, so the
// dev fallback below NEVER reaches the production bundle — the build
// either has the real prod URL inlined, or fails the runtime guard.

const FALLBACK_DEV_URL = "http://localhost:5255";

export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL || FALLBACK_DEV_URL;

// Loud warning if a production build was made without setting the env
// var. Visible in the browser console immediately on load so it can't
// silently fall back to localhost.
if (
  process.env.NODE_ENV === "production" &&
  !process.env.REACT_APP_SERVER_URL
) {
  // eslint-disable-next-line no-console
  console.error(
    "[config] REACT_APP_SERVER_URL is not set. " +
      "API calls will fall back to " +
      FALLBACK_DEV_URL +
      " and fail. Set it in client/.env.production before running `npm run build`."
  );
}

export default SERVER_URL;
